import type { ButtonHTMLAttributes, ReactNode } from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
  children: ReactNode;
}

/** A button — the `--fawkes-btn-*` vocabulary, primary/secondary variants. */
export function Button({ variant = "primary", children, className, ...rest }: ButtonProps) {
  const classes = ["fui-button", `fui-button--${variant}`, className].filter(Boolean).join(" ");
  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
